import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { slideDownUp } from '../shared/animations';
import { AuthService } from '../service/auth/auth.service';
import { AlertService } from '../service/alerts.service';

@Component({
    selector: 'sidebar',
    templateUrl: './sidebar.html',
    animations: [slideDownUp],
})
export class SidebarComponent implements OnInit {
    active = false;
    store: any;
    activeDropdown: string[] = [];
    parentDropdown: string = '';
    user: any;

    constructor(
        public translate: TranslateService,
        public storeData: Store<any>,
        public router: Router,
        public authService: AuthService,
        public alertService: AlertService,
    ) {
        this.initStore();
    }

    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }
  
    ngOnInit() {
        this.user = this.authService.getUserData();
        this.setActiveDropdown();
    }
    
    // ===============================
    // PERMISSION CHECK METHODS
    // ===============================
    
    /**
     * Check if user has access to a specific module
     */
    hasAccess(moduleCode: string): boolean {
        return this.authService.hasModuleAccess(moduleCode);
    }

    /**
     * Check if user has access to any adherent modules
     */
    hasAdherentAccess(): boolean {
        return this.hasAccess('FDSA') || this.hasAccess('EPA') || this.hasAccess('PECA') ||
               this.hasAccess('ALDA') || this.hasAccess('ADHA') ||
               this.hasAccess('RECA');
    }

    /**
     * Check if user has access to any partenaire modules
     */
    hasPartenaireAccess(): boolean {
        return this.hasAccess('PECP') || this.hasAccess('INFO') || this.hasAccess('RECP');
    }

    /**
     * Check if user is admin (for configuration section)
     */
    isAdmin(): boolean {
        return this.hasAccess('CONF') || this.hasAccess('CONP') || this.hasAccess('PART') || this.hasAccess('ADHP') || this.hasAccess('UTIL') || this.hasAccess('STAT');
    }

    // ===============================
    // UI INTERACTION METHODS
    // ===============================

    setActiveDropdown() {
        const selector = document.querySelector('.sidebar ul a[routerLink="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link') || [];
                if (ele.length) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            }
        }
    }

    toggleMobileMenu() {
        if (window.innerWidth < 1024) {
            this.storeData.dispatch({ type: 'toggleSidebar' });
        }
    }

    toggleAccordion(name: string, parent?: string) {
        if (this.activeDropdown.includes(name)) {
            this.activeDropdown = this.activeDropdown.filter((d) => d !== name);
        } else {
            this.activeDropdown.push(name);
        }
    }

    async logout() {
        const alertOptions = {
            title: "Se déconnecter",
            text: "Êtes-vous sûr de vouloir vous déconnecter ?",
            confirmButtonText: "Confirmer",
            cancelButtonText: "Annuler",
        }
        
        const isConfirmed = await this.alertService.confirmDialog(alertOptions);
        
        if (isConfirmed) {
            this.authService.logout();
        }
    }
}